const serviceErrors = [
    'BANK_DISABLED',
    'CIRCUIT_BREAKER_OPEN',
    'BANK_CORE_SERVICE_UNAVAILABLE',
    'BANK_CORE_SERVICE_SYSTEM_ERROR',
];
export default (error) => {
    return serviceErrors.includes(error.errorName);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNTZXJ2aWNlRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvaXNTZXJ2aWNlRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxhQUFhLEdBQUc7SUFDbEIsZUFBZTtJQUNmLHNCQUFzQjtJQUN0QiwrQkFBK0I7SUFDL0IsZ0NBQWdDO0NBQ25DLENBQUM7QUFDRixlQUFlLENBQUMsS0FBbUMsRUFBRSxFQUFFO0lBQ25ELE9BQU8sYUFBYSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLENBQUM7QUFDbkQsQ0FBQyxDQUFDIn0=